import { resolveNativeApiUrl } from './nativeApiRouting';
import { throwAccountAwareError } from './hostWebAppRequiredAccess';

/** Do not let Safari's JSON parsing exception become the Office screen. */
export async function readCompanyRecords(headers: HeadersInit): Promise<any> {
  for (let attempt = 0; attempt < 2; attempt++) {
    let response: Response;
    let data: any;
    try {
      response = await fetch(resolveNativeApiUrl('/api/company-dashboard/records'), { headers, cache: 'no-store' });
      const text = await response.text();
      data = JSON.parse(text);
      if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid records response');
    } catch {
      if (attempt === 0) continue;
      throw new Error('Company records could not load. Try again.');
    }
    if (!response.ok) {
      if (attempt === 0 && response.status >= 500) continue;
      throwAccountAwareError(data, response.status, 'Company records could not load. Try again.');
    }
    if (!data.company || !Array.isArray(data.summary) || !Array.isArray(data.recentRecords)) {
      if (attempt === 0) continue;
      throw new Error('Company records could not load. Try again.');
    }
    return data;
  }
}
